// import htmlDecode from '../../utils/htmlDecode';
import getAppConfig from '../../config/appConfig';
import Utils from './../../utils/Utils';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Metadata from '../../requests/apa/Metadata';
import store from '../../store';
import { showModal, MODAL_REINTENTO } from '../../actions/modal';
import {ENABLE_MODAL_RETRIES, DISABLE_HTTPS, ENABLE_400_AS_200, ENABLE_401_AS_200, ENABLE_409_AS_200, ENABLE_422_AS_200, ENABLE_304_AS_200, ENABLE_429_AS_200, ENABLE_404_AS_200, ENABLE_402_AS_200, ENABLE_500_AS_200, ENABLE_501_AS_200} from '../RequestManagerConstants';
import { Database } from '../../AAF/Database/main';
class AbstractRequestTask {

    statusCode400As200 = ENABLE_400_AS_200;
    statusCode409As200 = ENABLE_409_AS_200;
    statusCode401As200 = ENABLE_401_AS_200;
    statusCode422As200 = ENABLE_422_AS_200;
    statusCode304As200 = ENABLE_304_AS_200;
    statusCode429As200 = ENABLE_429_AS_200;
    statusCode404As200 = ENABLE_404_AS_200;
    statusCode402As200 = ENABLE_402_AS_200;
    statusCode500As200 = ENABLE_500_AS_200;
    statusCode501As200 = ENABLE_501_AS_200;
    isByHttps = DISABLE_HTTPS;
    showErrorModal = ENABLE_MODAL_RETRIES;
    retriesNumer  = parseInt(Metadata.get('request_num_retries', 3));


    success(data, b) {
        if (data.errors || !data.response) {
            return false;
        }

        return true;
    }

    isValid(data) {
        if (data.errors || !data.response || data.response === 'error') {
            // Nuevas apis versionadas
            if (data.data){
                return true
            }
            return false;
        }

        return true;
    }

    getResponseType(){
        return "";
    }

    replaceProtocol(url) {
    let newUrl = url;

    const signalKey = newUrl.indexOf('signalKey') === -1;
    const social = newUrl.indexOf('www.clarovideo.com') === -1;
    const cert = newUrl.indexOf('getcertificate') === -1;
    const internalArrisUrl = newUrl.indexOf('http://session/') === -1;
    if (
      window.location &&
      window.location.protocol &&
      signalKey &&
      social &&
      cert &&
      internalArrisUrl
    ) {
      newUrl = newUrl.replace('https:', window.location.protocol);
      newUrl = newUrl.replace('http:', window.location.protocol);
    }
    return newUrl;
  }
    // implementar este metodo en el task especifico si no se debe mostrar modal de error-reintento
    getShowErrorModal(){
        return this.showErrorModal;
    }

    setShowErrorModal(show){
        this.showErrorModal = show;
    }

    error(data, b) {
        const newError = this.parseErrors(data);
        this.reject(newError, b);
    }

    parseErrors(err) {

        //Esta linea evita errores cuando err es undefined y no se encuentra en Andina, pero si en global
        if(!err) {
            err = {}
        }
        // FIN

      if (typeof window.newrelic === 'object') {
        console.log('Newrelic Error parseErrors', err);
        window.newrelic.noticeError(err);
      }
        let message;
        let code = null;
        let extendedMessage;

        if (err && err.errors && err.errors["0"] && err.errors["0"].code) {
            code = err.errors["0"].code;
            message = err.errors["0"].message;
            // /**
            //  * solo para apis de transacciones
            //  */
            if (err.errors[0].externalServiceInfo) {
                const { externalServiceInfo: {resultCode = '', resultMessage = ''} } = err.errors[0];
                extendedMessage = {
                    resultCode: resultCode,
                    resultMessage: resultMessage
                }
            }
        }
        else if (err && err.errors) {
            if (err.errors.msg) {
                message = err.errors.msg;
            } else if (Array.isArray(err.errors.error)) {
                message = err.errors.error[0];
            } else {
                message = err.errors.error;
            }
            if (err.errors.code)
                code = err.errors.code;

        }
        else if(err.error){
            message = err.error.message || err.error.description;
            code = err.error.code;
        }
        else if(err.status == false || !err.status) {
            message = err.message || err.description;
            code = err.code;
        }
        else if (err) {
            message = err.msg || null;
        }
        else {
            message = 'Unknow';
        }

        return {
            // message: htmlDecode(message),
            message: message,
            completeError: err,
            code,
            extendedMessage
        };

    }

    /*
        Para métodos POST, tipos:
        1. application/x-www-form-urlencoded - DEFAULT
        2. text/plain - TODO see @ src/requests/Ajax.js
        3. multipart/form-data
    */
    getEncType() {
      return 'application/x-www-form-urlencoded';
    }

    getShowModal(){
      return true;
    }

    getRetriesNumber(){
      return this.retriesNumer;
    }

    setRetriesNumber(n){
        this.retriesNumer = n;
    }

    getIsByHttps(){
        return this.isByHttps;
    }

    setIsByHttps(isHttps){
        this.isByHttps = isHttps;
    }

    getParams() {
        const config = getAppConfig();
        const HKS = DeviceStorage.getItem("HKS") || "";

        const region = DeviceStorage.getItem("region");
        const user = store.getState().user;
        let user_token = DeviceStorage.getItem('user_token');
        // Get from memory... just in case...
        if(!user_token) {
            user_token = Database.getUserToken();
        }
        const params = {
            user_token: user_token,
            api_version: config.api_version,
            authpn: config.authpn,
            authpt: config.authpt,

            device_category: config.device_category,
            device_manufacturer: config.device_manufacturer,
            device_model: config.device_model,
            device_type: config.device_type,

            device_id: config.device_id,
            device_name: config.device_name,
            device_so: config.device_so,

            region: region,
            format: config.format
        };

        if(HKS) params.HKS = HKS;

        const userIdEnabled = Utils.getApaMetadataKey('sticky_session', '{"push_session":false,"user_id":false}', 'user_id');

        if(userIdEnabled && user && user.user_id){
            return Object.assign({}, params, this.params, { user_id: user.user_id});
        }

        return Object.assign({}, params, this.params);
    }

    getMethod() {
        return 'GET';
    }

    getUrl() {
        return this.url;
    }

    getHeaders() {
        if (this.getMethod() === "POST" || this.getMethod() === "PUT")
        return {
            "Access-Control-Allow-Origin": "*",
        };
        else return null;
    }

    setStatusCode409As200(value){
        this.statusCode409As200 = value;
    }

    getStatusCode409As200(){
        return this.statusCode409As200;
    }

    setStatusCode400As200(value){
        this.statusCode400As200 = value;
    }

    getStatusCode400As200(){
        return this.statusCode400As200;
    }

    setStatusCode401As200(value){
        this.statusCode401As200 = value;
    }

    getStatusCode401As200(){
        return this.statusCode401As200;
    }

    setStatusCode422As200(value){
      this.statusCode422As200 = value;
    }

    getStatusCode422As200(){
      return this.statusCode422As200;
    }

    setStatusCode304As200(value) {
        this.statusCode304As200 = value;
    }

    getStatusCode304As200() {
        return this.statusCode304As200;
    }

    getStatusCode429As200() {
        return this.statusCode429As200;
    }

    getStatusCode404As200() {
        return this.statusCode404As200;
    }

    setStatusCode402As200(value) {
        this.statusCode402As200 = value;
    }

    getStatusCode402As200() {
        return this.statusCode402As200;
    }

    setStatusCode500As200(value) {
        this.statusCode500As200 = value;
    }

    getStatusCode500As200() {
        return this.statusCode500As200;
    }

    setStatusCode501As200(value) {
        this.statusCode501As200 = value;
    }

    getStatusCode501As200() {
        return this.statusCode501As200;
    }

    showModalRetry(handleRetry, handleReject, isUnsupportedProvider = false){
        store.dispatch(showModal({
            modalType: MODAL_REINTENTO,
            modalProps: {
                onReject: () => handleReject('Can not get request'),
                onRetry: () => handleRetry(),
            url: this.getUrl(),
            isUnsupportedProvider
            }
        }))
    }

    getIsVTT(){
        return false;
    }
}

export default AbstractRequestTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/AbstractRequestTask.js